import React, { useState } from 'react';
import UIBody from '../../../components/ui/UIBody';
import { motion } from "framer-motion";
import {
  FaAward,
  FaCertificate,
  FaStar,
  FaHandsHelping,
  FaUserEdit,
  FaChalkboardTeacher,
  FaPuzzlePiece,
  FaGamepad,
  FaMedal
} from 'react-icons/fa';
const KidaCourseDetailPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
  });
  const [isSticky, setIsSticky] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
  };
  return (
    <UIBody
      content={
        <div className="">
          {/* Intro Section */}
          <motion.div
            className="row justify-content-center mt-3 mb-5"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            <section>
              <div className="container ">
                <div className="card shadow program-details-section">
                  <div className="card-body px-lg-5">
                    <h3 className="text-white">Creative Coding for Kids</h3>
                    <p className="text-white programe-content">
                      Let your child explore the fun world of coding with our interactive and playful learning experience. Designed for young minds, this program builds logic, creativity, and digital confidence through storytelling and games.
                    </p>
                    {/* Certificates & Achievements Mini Cards */}
                    <div className="d-flex gap-2 flex-wrap mt-3">
                      {[
                        { title: "Completion Certificate", icon: <FaCertificate size={22} className="text-warning" /> },
                        { title: "Creativity Award", icon: <FaAward size={22} className="text-danger" /> },
                        { title: "Coding Star Badge", icon: <FaStar size={22} className="text-info" /> },
                        { title: "Teamwork Badge", icon: <FaHandsHelping size={22} className="text-success" /> },
                      ].map((item, idx) => (
                        <div
                          key={idx}
                          className="program-details-mini-card py-2 px-3 rounded shadow d-flex align-items-center gap-2"
                        >
                          {item.icon}
                          <b className="text-white">{item.title}</b>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </motion.div>
          {/* Main Container */}
          <div className="container">
            <div className="row g-0">
              {/* Left Section */}
              <div className="col-lg-7">
                <div>
                  <img
                    src="/images/ui/kids/group-giggling-latinx-children-film-stopmotion-animation-kitchen-table-using-colorful-clay-figures-vegetables-as-props-playful-collaborative.jpg"
                    alt="Kids Course Banner"
                    className="kids-details-img w-100"
                  />
                </div>
                {/* Journey Section */}
                <motion.section
                  className="container my-5 "
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1 }}
                >
                  <h3 className="text-center mb-4 fw-bold text-primary">Journey from Enrollment to Achievement</h3>
                  <div className="row justify-content-center">
                    {[
                      {
                        title: "Enrollment",
                        desc: "Fill out the form to enroll your child in our fun and interactive coding course.",
                        icon: <FaUserEdit size={30} />
                      },
                      {
                        title: "Welcome Session",
                        desc: "Parents and kids join a short intro session to understand how we make learning fun!",
                        icon: <FaChalkboardTeacher size={30} />
                      },
                      {
                        title: "Interactive Lessons",
                        desc: "Kids enjoy coding lessons with storytelling, puzzles, and creative projects.",
                        icon: <FaPuzzlePiece size={30} />
                      },
                      {
                        title: "Creative Projects",
                        desc: "Children build their own animations and simple games to boost confidence.",
                        icon: <FaGamepad size={30} />
                      },
                      {
                        title: "Certificates & Rewards",
                        desc: "Receive certificates, digital badges, and fun surprise goodies!",
                        icon: <FaMedal size={30} />
                      },
                    ].map((step, index) => (
                      <motion.div
                        key={index}
                        className="col-12 col-md-6 col-lg-4 mb-4"
                        whileHover={{ scale: 1.03 }}
                        transition={{ type: "spring", stiffness: 200 }}
                      >
                        <div className="card h-100 shadow-sm border-0 rounded-4 text-center p-4 journey-step">
                          <div className="mb-3 text-primary">{step.icon}</div>
                          <h5 className="fw-bold">{step.title}</h5>
                          <p className="text-muted small">{step.desc}</p>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </motion.section>
              </div>
              {/* Right Section: Sticky Contact Form */}
              <div className="col-lg-5">
                <div
                  className={`singUp-wrap shadow px-4 py-4 ${isSticky ? 'sticky-hover' : ''}`}
                  style={isSticky ? { position: 'sticky', top: '80px', zIndex: 1000 } : {}}
                  onMouseEnter={() => setIsSticky(true)}
                  onMouseLeave={() => setIsSticky(false)}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Get in Touch</h4>
                  </div>
                  <p className="text-muted mb-2">
                    Fill out the form and our friendly team will contact you to guide you through the enrollment process.
                  </p>
                  <form className="account__form" onSubmit={handleSubmit}>
                    <div className="row gutter-20">
                      <div className="col-md-6">
                        <div className="form-grp">
                          <label htmlFor="first-name">First Name</label>
                          <input
                            type="text"
                            id="first-name"
                            placeholder="First Name"
                            onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-grp">
                          <label htmlFor="last-name">Last Name</label>
                          <input
                            type="text"
                            id="last-name"
                            placeholder="Last Name"
                            onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-grp">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        placeholder="Email Address"
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      />
                    </div>
                    <div className="form-grp">
                      <label htmlFor="mobile">Mobile Number</label>
                      <input
                        type="number"
                        id="mobile"
                        placeholder="Mobile Number"
                        onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                      />
                    </div>
                    <button type="submit" className="btn rounded">Sign Up</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};
export default KidaCourseDetailPage;